import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import ImageSlider from 'react-slick'

import { browserUtils } from '../../utils'
import './ImageCarousel.sass'


const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  accessibility: true,
  fade: true,
  speed: 330,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: browserUtils.isMobileOrTabletDevice(),
  autoplaySpeed: 5000,
};

// Shim for IE11 and Edge to implement forEach on a Nodelist
// Source: http://tips.tutorialhorizon.com/2017/01/06/object-doesnt-support-property-or-method-foreach/
(function () {
  if ( typeof NodeList.prototype.forEach === "function" ) return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

class ImageCarousel extends Component {
  componentDidMount() {
    // Resolves issue with height not being recalculated on cache-cleared page load when adaptiveHeight enabled
    // Source: https://github.com/akiran/react-slick/issues/344#issuecomment-284870684
    const imgs = ReactDOM.findDOMNode(this.slider).querySelectorAll('img');
    let loadedImgs = 0;
    imgs.forEach((img) => {
      img.onload = () => {
        loadedImgs += 1;
        if (this.slider && loadedImgs === imgs.length) {
          this.slider.innerSlider.adaptHeight();
        }
      };
    });
  }

  renderImages(images) {
    return images.map((image, idx) =>
      <img key={idx} src={image} alt="carousel image" />
    )
  }

  render() {
    return (
      <ImageSlider {...settings} ref={(comp) => this.slider = comp}>
        {this.renderImages(this.props.images)}
      </ImageSlider>
    )
  }
}

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.string
  )
}

export default ImageCarousel
